import ActionTypes from '../../actionTypes';
import API from '../../../API';
import { dateToUrlDate, toMonthString } from '../../../shared/functions';
/**
 * Action creator for the fetch newspapers by month and publication GET request
 */
var getNewspapersByMonthAndPublicationGetRequest = function () { return ({
    type: ActionTypes.FETCH_NEWSPAPERS_GET_REQUEST,
}); };
/**
 * Action creator for the fetch newspapers by month and publication GET response
 */
var getNewspapersByMonthAndPublicationGetResponse = function (data) { return ({
    type: ActionTypes.FETCH_NEWSPAPERS_GET_RESPONSE,
    payload: data,
}); };
/**
 * Action creator for the fetch newspapers by month and publication GET invalidate
 */
var getNewspapersByMonthAndPublicationGetInvalidate = function (error) { return ({
    type: ActionTypes.FETCH_NEWSPAPERS_GET_INVALIDATE,
    error: error,
}); };
/**
 * Returns a function that fetches data from the newspapers API and performs
 * the subsequent dispatch operations to send the data or the error to the store.
 */
var fetchNewspapersByMonthAndPublication = function (date, publicationId) { return function (dispatch) {
    dispatch(getNewspapersByMonthAndPublicationGetRequest());
    var month = toMonthString(dateToUrlDate(date));
    return API.getNewspapersByMonthAndPublication(date, publicationId)
        // Specify the first 6 characters of datestring as date, which will be year + month
        .then(function (newspapers) {
        var _a;
        return dispatch(getNewspapersByMonthAndPublicationGetResponse((_a = {}, _a[month] = newspapers, _a)));
    })
        .catch(function (error) { return dispatch(getNewspapersByMonthAndPublicationGetInvalidate(error.message)); });
}; };
export default fetchNewspapersByMonthAndPublication;
